// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import TableOutlined from '/Users/zhangmin/Documents/project/jsq/paas_backend/node_modules/@ant-design/icons/es/icons/TableOutlined';
import FolderOutlined from '/Users/zhangmin/Documents/project/jsq/paas_backend/node_modules/@ant-design/icons/es/icons/FolderOutlined';
export default { TableOutlined, FolderOutlined };
